import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { GettingStartedPage } from '#features/onboarding/getting-started-page.tsx'

export const Route = createFileRoute('/_app/getting-started/')({
  validateSearch: z.object({
    workspace: z.string().optional(),
  }),
  head: () => ({
    meta: [
      {
        title: 'Getting Started',
      },
    ],
  }),
  component: GettingStartedPage,
})
